import React, { useEffect, useState } from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useResponsive from '../../hooks/useResponsive';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../layout/dashboard/header';

import { getUrlPathTextId } from '../../utils/url-id';
import { useAuth } from '../../hooks/useAuth';
import { useMutation } from '@tanstack/react-query';
import { apiGetMedicByIdEmployments } from '../../api/medic';
import { useNotificationService } from '../../components/notification';
import { MedicEmploymentProps } from '../../interface/medic';
import MedicEmploymentInfo from '../../components/medic/MedicEmploymentInfo';
import BackButton from '../../components/UIElements/BackButton';

const MedicEmployment = () => {
  const theme = useTheme();
  const isMedium = useResponsive('down', 'md', 'xl');
  const isSmall = useResponsive('down', 'sm', 'xl');
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useAuth();
  const { showNotification } = useNotificationService();
  const [medic_employment, setMedic_employment] = useState<
    MedicEmploymentProps[]
  >([]);

  useEffect(() => {
    const medicId = getUrlPathTextId(location?.pathname);
    const fields = { medicId: medicId, token: token };
    mutation.mutate(fields);
  }, []);

  const mutation = useMutation({
    mutationFn: (fields: { medicId: string; token: string }) =>
      apiGetMedicByIdEmployments(fields),
    onSuccess: (data) => {
      if (data?.status === 'error') {
        if ('msg' in data) {
          showNotification(data?.msg ?? '', 'error');
          return;
        }
        return;
      }
      if ('data' in data) {
        setMedic_employment(data.data.data);
      }
    },
    onError: (error) => {
      showNotification('Fetch process failed', 'error');
    },
  });

  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginRight: '1rem',
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={'row'} alignItems={'center'} sx={{ gap: '10px' }}>
            <BackButton />
            <Typography
              variant={'subtitle1'}
              sx={{
                fontWeight: 500,
                fontFamily: 'Lexend',
                color: theme.palette.secondary.dark,
              }}
            >
              Medic Employment
            </Typography>
          </Stack>
        </Box>
      </Header>
      <MedicEmploymentInfo
        medicEmployment={medic_employment}
        loading={mutation.isPending}
      />
    </>
  );
};

export default MedicEmployment;
